import React from 'react';
import { NavLink } from 'react-router-dom';
const Header = () => {
    return (
        <header className="navbar navbar-expand-md navbar-dark">
            <div className="container">
                <NavLink className="navbar-brand" exact to="/">Matthew Dove</NavLink>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#headerTabs" aria-controls="headerTabs" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon" />
                </button>

                <div className="collapse navbar-collapse" id="headerTabs">
                    <div className="navbar-nav ml-auto">
                        <NavLink className="nav-item" exact to="/">Home</NavLink>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/common/Header.js